<template>
  <v-container
    fluid
    fill-height
    class="pa-0"
  >
    <v-slide-y-transition mode="out-in">
      <v-layout column>
        <l-map
          :center="center"
          :options="mapOptions"
          :zoom="zoom"
          ref="map"
        >
          <l-tile-layer
            :url="url"
            :attribution="attribution"
            :options="{useCache: true}"
          />
          <l-circle-marker
            v-if="location"
            :lat-lng="[location.latitude, location.longitude]"
            :radius="6"
            :fill="true"
            :fill-opacity="0.3"
          />
          <l-control-zoom :position="zoomPosition" />
        </l-map>
        <h2 class="pa-1 text-xs-center black white--text" v-if="stroll">
          <v-icon class="white--text">navigation</v-icon>
          Directions to {{ stroll.title }}
        </h2>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import StrollMixin from '@/mixins/StrollMixin'
import L from 'leaflet'
import 'leaflet-routing-machine'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'

export default {
  name: 'Directions',

  mixins: [StrollMixin],

  data() {
    return {
      control: null,
    }
  },

  methods: {
    triggerDirections() {
      const mapObject = this.$refs.map.mapObject
      const userCoordinates = [this.location.latitude, this.location.longitude]
      const strollCoordinates = this.stroll.point.coordinates

      if (!this.location.latitude && !this.location.longitude) {
        this.control = null
        return
      }

      const control = L.Routing.control({
        waypoints: [
          L.latLng(userCoordinates),
          L.latLng(strollCoordinates),
        ],
        collapsible: true,
      })

      if (!this.control) {
        this.control = control
        control.addTo(mapObject)
      }

      // Zoom and pan to fit the route on the map
      mapObject.fitBounds(
        [userCoordinates, strollCoordinates],
        {
          animate: true,
        }
      )
    },

  },

  watch: {
    location() {
      this.triggerDirections()
    },

    stroll() {
      this.triggerDirections()
    }
  },
}
</script>

<style lang="sass">
.leaflet-routing-container
  border-radius: 0
  border: none
  font-family: Roboto
  font-size: 14px
  padding-top: .75em !important

  table
    td
      padding-bottom: .25em
      padding-top: .25em

.leaflet-touch .leaflet-control-layers, .leaflet-touch .leaflet-bar
  border: none !important
  border-radius: 0

.leaflet-routing-collapse-btn
  cursor: pointer
  right: 12px
  top: -7px

.leaflet-routing-container-hide .leaflet-routing-collapse-btn
  cursor: pointer
  left: 1px
  top: -7px
</style>
